export const getCount = state => {
    return state.count
}


// WEBPACK FOOTER //
// ./src/components/store/getters.js